/* eslint-disable new-cap */
import { Partial, type Static, String } from 'runtypes';

export const VERSION_PARAM = 'v';

// Query param values have been formatted to lowercase
export enum QP_VALUE {
  CREATE_JOB = 'createjob',
  COPY_JOB = 'copyjob',
  EDIT_DRAFT = 'editdraft',
}

export const defaultQueryParams: QueryParams = {};

export const QueryParams = Partial({
  advertiserid: String,
  draftid: String,
  jobid: String,
  referrer: String,
  promocodes: String,
  [VERSION_PARAM]: String,
});

export type QueryParams = Static<typeof QueryParams>;

export const POSTED_JOB_ID = 'postedjobid';
